import { Column } from 'shared/types/models/EditMetrics';

import { compareBudgetMetricId } from '../../../constants';

export function isComparingBudgetColumn(column: Column) {
  return column.kind === 'metric' && column.metricID === compareBudgetMetricId;
}
